// @flow

import React from 'react';
import bemify from 'bemify-js';

import { Link } from '@zapier/design-system';

import { buildStaticAssetPath } from 'web-ssr/app/common/next/utils';

// !!! IMPORTANT !!!
//
// The SCSS styles used by this component are no longer accessible. In order to
// modify this component you will need to refactor it to use CSS-in-JS

const bem = bemify('logo');

type Props = {
  className?: string,
};

const Logo = (props: Props) => {
  const { className = '' } = props;
  const path = buildStaticAssetPath('images/zapier-small-orange-logo.png');

  return (
    <span className={bem(className)}>
      <Link href="/">
        <img alt="Zapier Logo" className={bem('__image')} src={path} />
      </Link>
    </span>
  );
};

export default Logo;
